import React, { Component } from 'react';
import '../../css/chat/chat.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ChatControlsMenu extends Component {
    constructor() {
        super();
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

    }

    componentDidMount() {
        document.addEventListener("mouseup", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mouseup", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.props.showButtons && this.wrapperRef && !this.wrapperRef.current.contains(e.target) && !this.props.invoker.current.contains(e.target)) {
            this.props.toggleButtons();
        }
    }

    render() {
        return (

            <div ref={this.wrapperRef} className='position-absolute' style={{ bottom: "80px", left: "115px" }}>
                <div style={{ transform: "none" }} className={"position-relative menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color py-4 fs-6 w-200px " + (this.props.showButtons ? "show" : "")} >
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.handleAttachClick} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("paperclip-vertical")} />  {this.props.t("attach")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.toggleFaqModal} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("comments-question")} />  {this.props.t("FAQ")}</span>
                        </a>
                    </div>
                    <div className="menu-item px-5">
                        <a href='/' onClick={this.props.handleVideoCall} className="menu-link px-5">
                            <span><FontAwesomeIcon icon={duotone("video")} />  {this.props.t("videocall")}</span>
                        </a>
                    </div>
                </div>
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(ChatControlsMenu);